var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#52C0A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5c-3.3 0-6 2.65-6 5.95V13c0 1.4 1.1 2.5 2.5 2.5.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5-.55 0-1.1.2-1.5.5v-.1C7 8.2 9.25 6 12 6s5 2.2 5 4.95V11c-.4-.3-.95-.5-1.5-.5-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5.35 0 .7-.1 1-.2-.5 1.05-1.4 1.85-2.5 2.3v-.1c0-.3-.2-.5-.5-.5H12c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5 3.3 0 6-2.6 6-5.8v-2.25C18 7.65 15.3 5 12 5z",
    fill: "#fff"
  })));
}

export default SvgSupportIcon;